import { PageWithMenu } from '../../../lib/components';
import { useTranslation } from 'react-i18next';
import { Outlet, useOutletContext } from 'react-router';
import { Dispatch, SetStateAction } from 'react';
import { observer } from 'mobx-react-lite';
import { exportsSubmenuConfig } from '../../../submenus';

interface Context {
  date: [Date, Dispatch<SetStateAction<Date>>];
  context: string;
}

export function useDate() {
  return useOutletContext<Context>().date;
}

export function usePageContext() {
  return useOutletContext<Context>().context;
}

export const ExportsPagesPartial = observer(() => {
  const { t } = useTranslation();

  return (
    <PageWithMenu menuConfig={exportsSubmenuConfig(t)}>
      <Outlet context={{ context: 'exports' }} />
    </PageWithMenu>
  );
});
